import { FC } from "react";
import Section from "apps/website/components/layout/Section/Section";
import Grid from "apps/website/components/layout/Grid/Grid";
import Column from "apps/website/components/layout/Column/Column";
import { Theme } from "apps/website/maps/Theme.map";
import highlightTextWithHTML from "apps/website/utils/website/highlightTextWithHTML";
import { useTrustpilot } from "apps/website/hooks/useTrustpilot";

import TextTitle from "../../base/Text/TextTitle/TextTitle";
import TextSubtitle from "../../base/Text/TextSubtitle/TextSubtitle";
import Spacer from "../../layout/Spacer/Spacer";
import Button from "../../base/Button/Button";
import { ILink } from "../../base/Button/Button.map";
import Container from "../../layout/Container/Container";
import Image, { IImageProps } from "../../base/Image/Image";
import TrustPilotStars from "../../misc/TrustPilotStars";
import TextBody from "../../base/Text/TextBody/TextBody";

export interface ISectionTextImageSocialProofHeroProps {
  theme?: Theme;
  title: string;
  subtitle: string;
  image: IImageProps;
  cta: ILink;
  reviewHeader: string;
  reviewFooter: string;
}

const SectionTextImageSocialProofHero: FC<ISectionTextImageSocialProofHeroProps> = ({
  theme = "default",
  title,
  subtitle,
  image,
  cta,
  reviewHeader,
  reviewFooter,
}) => {
  const { interpolate } = useTrustpilot();
  return (
    <Section theme={ theme } component={ SectionTextImageSocialProofHero.name } size={ "none" } className="overflow-hidden h-fit relative">
      <div className="relative aspect-video xl:static w-full xl:aspect-auto h-[150px] xl:h-full xl:w-1/2 xl:absolute xl:top-0 xl:right-0">
        <Image image={image} alt={title} cover />
      </div>
      <Container>
        <Grid gap="lg">
          <Column spans={ { xl: 6 }} justify="center" align="center" className="xl:px-16">
            <Spacer size="lg" />
            <TextTitle
              tag="h1"
              size={1}
              align="center"
              whitespace="balance"
              data-testid="TextImageSocialProofHeroTitle"
            ><span dangerouslySetInnerHTML={ { __html: highlightTextWithHTML({ text: ` ${title} `, display: "inline-block", rotate: true }) } }/></TextTitle>
            <Spacer size="lg" />
            <TextSubtitle
              tag="h2"
              align="center"
              size={1}
              whitespace="balance"
              data-testid="TextImageSocialProofHeroSubtitle"
            >{ subtitle }</TextSubtitle>
            <Spacer size="lg" />
            <Button
              data-testid="TextImageSocialProofHeroButton"
              to={ cta.to }
              size="full-width"
            >{ cta.name }</Button>
            <Spacer size="lg" />
            <Grid className={"w-full"}>
              <Column align="center">
                <TextSubtitle tag="h3" size={ 2 } align="center">{ interpolate(reviewHeader) }</TextSubtitle>
                <Spacer size="md" />
                <div className="w-[120px]">
                  <TrustPilotStars />
                </div>
                <Spacer size="md" />
                <TextBody tag="p" size={ 3 } align="center">{ interpolate(reviewFooter) }</TextBody>
                <Spacer size="lg" />
              </Column>
            </Grid>
          </Column>
        </Grid>
      </Container>
    </Section>
  );
};

export default SectionTextImageSocialProofHero;
